import { setValue, deepcopy } from './utility.js';

export async function ViewTransformation(role, spec, original, specifier, action, option) {
  if (action === "add") {
    // todo
    if (option?.role === "row" || option?.role === "column") {
      let fields = [];
      if (option?.field.constructor.name === "Array") {
        fields = deepcopy(option.field);
      } else if (option?.field.constructor.name === "String") {
        fields = [option.field];
      }
      fields.forEach((field, fi) => {
        let newRCObj = { "field": field };
        Object.keys(option).forEach(propKey => {
          if (!["role"].includes(propKey)) {
            let newValue;
            if (option[propKey]?.constructor.name === "Array" && option[propKey]?.length >= fields.length) {
              newValue = option[propKey][fi];
            } else if (option[propKey]?.constructor.name === "Array" && option[propKey]?.length < fields.length) {
              newValue = option[propKey][d3.min(fi, option[propKey].length)];
            } else {
              newValue = option[propKey];
            }
            if (propKey === "sort") {
              let sortValue = {};
              if (newValue.sortBy !== undefined) { sortValue.order = deepcopy(newValue.sortBy); }
              if (newValue.field !== undefined) { sortValue.field = newValue.field; }
              if (newValue.reverse !== undefined) { newRCObj.reverse = newValue.reverse; }
              newValue = sortValue;
            }
            if (newValue !== null) {
              let _propKey = { "datatype": "type" }[propKey] || propKey;
              newRCObj[_propKey] = newValue;
            }
          }
        });
        if (spec.layout[option.role] === undefined) spec.layout[option.role] = [];
        spec.layout[option.role].push(newRCObj);
      });
    } else if (option?.role === "title" || option.title !== undefined) {
      if (spec.title === undefined) spec.title = { items: [] };
      if (spec.title.items === undefined) spec.title.items = [];
      let newTitle = {}, titleOption;
      if (option.title !== undefined) {
        titleOption = option.title;
      } else {
        titleOption = option;
      }
      Object.keys(titleOption).forEach((propKey) => {
        if (["role"].includes(propKey)) return;
        let _propKey = { id: "name" }[propKey] || propKey;
        if (titleOption[propKey] === null) {
          delete newTitle[_propKey]
        } else newTitle[_propKey] = titleOption[propKey];
      });
      spec.title.items.push(newTitle);
    } else if (option?.role === "annotation" || option.annotation !== undefined) {
      if (spec.annotation === undefined) spec.annotation = { items: [] };
      if (spec.annotation.items === undefined) spec.annotation.items = [];
      let newAnnotation = { type: "text" }, annoOption;
      if (option.annotation !== undefined) {
        annoOption = option.annotation;
      } else {
        annoOption = option;
      }
      let perText = {};
      Object.keys(annoOption).forEach((propKey) => {
        if (["role"].includes(propKey)) return;
        let _propKey = { id: "name", textAlign: "align" }[propKey] || propKey;
        if (!["text", "textAlign", "fontSize", "color", "fontWeight", "lineHeight"].includes(propKey)) {
          if (annoOption[propKey] === null) {
            delete newAnnotation[_propKey]
          } else newAnnotation[_propKey] = annoOption[propKey];
        } else if (propKey === "text") {
          if (annoOption.text.constructor.name === "String") {
            newAnnotation.text = [{ text: annoOption.text }];
          } else if (annoOption.text.constructor.name === "Object") {
            newAnnotation.text = [text];
          } else if (annoOption.text.constructor.name === "Array") {
            newAnnotation.text = [];
            annoOption.text.forEach(text => {
              let newText = {};
              Object.keys(text).forEach(subKey => {
                let _subKey = { textAlign: "align" }[subKey] || subKey;
                if (text[subKey]) newText[_subKey] = text[subKey];
              })
              newAnnotation.text.push(newText);
            })
          }
        } else {
          perText[_propKey] = annoOption[propKey];
        }
      });
      Object.keys(perText).forEach(_propKey => {
        newAnnotation.text.forEach(text => {
          if (!text[_propKey]) text[_propKey] = perText[_propKey];
        })
      })
      spec.annotation.items.push(newAnnotation);
    }
  } else if (action === "remove") {
    // todo
  } else if (action === "modify") {
    if (option) {
      // resizing
      if (option.width) {
        if (option.proportionate == true) {
          spec = setValue(spec, ["layout", "height"], spec.layout.height * (option.width / spec.layout.width));
        }
        spec = setValue(spec, ["layout", "width"], option.width);
      }
      if (option.height) spec = setValue(spec, ["layout", "height"], option.height);
      else if (option.height === null) {
        delete spec.layout.height;
      }
      if (option.size) {
        spec = setValue(spec, ["layout", "width"], option.size[0]);
        spec = setValue(spec, ["layout", "height"], option.size[1]);
      }
      // downstream change
      if (option.width !== undefined || option.size?.[0] !== undefined) {
        let width = option.width || option.size?.[0];
        if (spec.title?.width !== undefined && parseFloat(spec.title.width) > parseFloat(width)) {
          spec.title.width = width;
        }
      }
      if (option.composition) {
        if (option.composition === null) {
          delete spec.layout.composition;
        }
        spec.layout.composition = option.composition;
        if (option.composition === "repeated") spec.layout.split = {};
        else delete spec.layout.split;
      }
      if (option.split !== undefined) {
        if (option.split === null) {
          delete spec.layout.split;
        } else {
          Object.keys(option.split).forEach(key => {
            spec = setValue(spec, ["layout", "split", key], option.split[key]);
          });
          if (!spec.layer) {
            spec.layer = [];
          }
          if (spec.layer.length == 0) {
            spec.layer.push({
              name: "layer_0",
              mark: { type: "point" }
            })
          }
        }
      }
      if (option.nColumns !== undefined) {
        if (option.nColumns === null) {
          delete spec.layout.nColumns;
        }
        else spec.layout.nColumns = option.nColumns;
      }
      if (option.projection !== undefined) {
        if (option.projection === null) {
          delete spec.layout.projection;
        }
        else {
          if (spec.layout.projection === undefined) spec.layout.projection = {};
          Object.keys(option.projection).forEach(propkey => {
            if (option.projection[propkey] === null) delete spec.layout.projection[propkey];
            else spec.layout.projection[propkey] = option.projection[propkey];
          });
        }
      }
      if (option.padding !== undefined) {
        if (!spec.layout.padding) {
          spec.layout.padding = {};
        }
        if (option.padding.constructor.name === "String") {
          let padding = {};
          value?.split(" ").forEach((v, i) => {
            if (i == 0) padding.top = parseFloat(v);
            else if (i == 1) padding.right = parseFloat(v);
            else if (i == 2) padding.bottom = parseFloat(v);
            else if (i == 3) padding.left = parseFloat(v);
          });
          spec.layout.padding = {};
        } else if (option.padding.constructor.name === "Array") {
          spec.layout.padding = {
            top: option.padding[0],
            right: option.padding[1],
            bottom: option.padding[2] || option.padding[0],
            left: option.padding[3] || option.padding[1],
          };
        } else if (option.padding.constructor.name === "Object") {
          Object.keys(option.padding).forEach((dir) => {
            spec.layout.padding[dir] = option.padding[dir];
          });
        }
      }
    }
  } else if (action === "replace") {
    // row-column transformation
    if ((option?.from?.role === "row" && option?.to?.role === "column") ||
      (option?.role?.from === "row" && option?.role?.to === "column") ||
      (option?.from?.role === "column" && option?.to?.role === "row") ||
      (option?.role?.from === "column" && option?.role?.to === "row") ||
      (option.role === "row" || option.role === "column")) {
      let roleFrom = option?.from?.role || option?.role?.from;
      if (!roleFrom) roleFrom = option.role;

      let roleTo = option?.to?.role || option?.role?.to;
      if (!roleTo) roleTo = option.role;

      let indexFrom, indexTo;
      if (option?.from?.index) indexFrom = option.from.index - 1;
      else if (option?.index?.from) indexFrom = option.index.to - 1;
      if (option?.to?.index) indexTo = option.to.index - 1;
      else if (option?.index?.to) indexTo = option.index.to - 1;

      let elementsFrom = (indexFrom !== undefined ? [deepcopy(original.layout[roleFrom][indexFrom])] : deepcopy(original.layout[roleFrom]));
      if (option?.from?.field) {
        elementsFrom = elementsFrom.filter((d, i) => { if (d === option.from.field || d.field === option.from.field) { indexFrom = i; return true } else return false; });
      } else if (option?.field?.from) {
        elementsFrom = elementsFrom.filter((d, i) => { if (d === option.field.from || d.field === option.field.from) { indexFrom = i; return true } else return false; });
      } else if (option?.field) {
        elementsFrom = elementsFrom.filter((d, i) => { if (d === option.field || d.field === option.field) { indexFrom = i; return true } else return false; });
      }
      if (elementsFrom.length > 0) {
        if (indexFrom !== undefined) {
          spec.layout[roleFrom].splice(indexFrom, 1)
        } else {
          delete spec.layout[roleFrom];
        }
        if (indexTo !== undefined) {
          spec.layout[roleTo].splice(indexTo, 0, ...elementsFrom);
        } else {
          spec.layout[roleTo] = spec.layout[roleTo].concat(elementsFrom);
        }
      }
    }
    const non_property = ["row", "column", "facet", "axis", "hAxis", "vAxis"];
    // property-wise change (todo)
    if (option.from !== undefined && option.to !== undefined) {

    } else {

    }
  } else if (action === "transpose") {

    let layer_specific = (specifier.layer !== undefined);
    let layer_index = (layer_specific ? specifier.layer.index || undefined : undefined);
    let layer_mark = (layer_specific ? specifier.layer.mark || undefined : undefined);

    let applied_layer_index;
    if (layer_specific) {
      applied_layer_index = spec.layer.map((layer, li) => {
        if (layer_index !== undefined && layer_mark !== undefined)
          return (layer.mark.type === layer_mark) && (li == layer_index) ? li : undefined;
        else if (layer_index !== undefined)
          return (li == layer_index) ? li : undefined;
        else if (layer_mark !== undefined)
          return (layer.mark.type === layer_mark) ? li : undefined;
      })
      applied_layer_index = applied_layer_index.filter(d => d !== undefined);
    }
    if (!applied_layer_index) {
      if (spec.layout.composition === "projection") {
        if (spec.layout.projection === undefined) spec.layout.projection = {};
        // needs update
        if (spec.layout.projection.transpose && spec.layout.projection.type === "transverseMercator") {
          spec.layout.projection.transpose = false;
          spec.layout.projection.type = "mercator";
        } else if (!spec.layout.projection.transpose && spec.layout.projection.type === "mercator") {
          spec.layout.projection.transpose = true;
          spec.layout.projection.type = "transverseMercator";
        }
      } else {
        let tempRow = deepcopy(spec.layout.row), tempCol = deepcopy(spec.layout.column);
        spec.layout.row = tempCol;
        spec.layout.column = tempRow;
        let tempHAxis = (spec.layout?.haxis !== undefined ? deepcopy(spec.layout.haxis) : null), tempVAxis = (spec.layout?.vaxis !== undefined ? deepcopy(spec.layout.vaxis) : null);
        if (tempHAxis !== null) {
          spec.layout.vaxis = tempHAxis;
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.type === "on-axis" && spec.layout.row.map(d => (d.constructor.name === "String" ? d : d.field)).includes(textItem.field)) {
                if (textItem.orient === "top" || textItem.orient === "bottom") textItem.orient = "left";
              }
            });
          });
        }
        else delete spec.layout.vaxis;
        if (tempVAxis !== null) {
          spec.layout.haxis = tempVAxis;
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.type === "on-axis" && spec.layout.column.map(d => (d.constructor.name === "String" ? d : d.field)).includes(textItem.field)) {
                if (textItem.orient === "left" || textItem.orient === "right") textItem.orient = "bottom";
              }
            });
          });
        } else delete spec.layout.haxis;

      }
      spec.layer.forEach((layer, li) => {
        let tempRow, tempCol;
        if (layer.row !== undefined) {
          tempRow = deepcopy(layer.row);
        }
        if (layer.column !== undefined) {
          tempCol = deepcopy(layer.column);
        }
        if (tempRow) {
          layer.column = tempRow;
          if (tempCol === undefined) {
            delete layer.row;
          }
        }
        if (tempCol) {
          layer.row = tempCol;
          if (tempRow === undefined) {
            delete layer.column;
          }
        }
      });
    } else {
      applied_layer_index.forEach(li => {
        let layer = spec.layer[li];
        let tempRow, tempCol;
        if (layer.row !== undefined) {
          tempRow = deepcopy(layer.row);
        }
        if (layer.column !== undefined) {
          tempCol = deepcopy(layer.column);
        }
        if (tempRow) {
          layer.column = tempRow;
          if (tempCol === undefined) {
            delete layer.row;
          }
        }
        if (tempCol) {
          layer.row = tempCol;
          if (tempRow === undefined) {
            delete layer.column;
          }
        }
      });
    }
  }
  return spec;
}


export async function ViewFacetTransformation(role, spec, original, specifier, action, option) {
  if (action === "modify") {
    if (option) {
      Object.keys(option).forEach(propKey => {
        if (propKey === "nColumns" && spec.layout.split !== undefined) {
          spec.layout.nColumns = option.nColumns;
        }
      })
    }
  }
  return spec;
}

export async function ViewFacetHeaderTransformation(role, spec, original, specifier, action, option) {
  if (!spec.layout.split) return spec;

  if (action === "modify") {
    if (option) {
      Object.keys(option).forEach(propKey => {
        if (propKey !== "items") {
          if (option[propKey] == null) {
            delete spec.layout.split.label[propKey];
          } else {
            if (spec.layout.split.label === undefined) spec.layout.split.label = {};
            spec.layout.split.label[propKey] = option[propKey];
          }
        } else {
          let items;
          if (option.items.constructor.name === "Object") items = [option.items];
          else if (option.items.constructor.name === "Array") items = option.items;
          items?.forEach((item, ii) => {
            let index;
            if (item.index !== undefined) index = item.index;
            else if (items.length > 1) index = ii;
            spec.layout.split.label.items?.forEach((textElem, ti) => {
              if (index !== undefined && ti !== index) return;
              Object.keys(item).forEach((subpropKey) => {
                let _subpropKey = { "align": "textAlign" }[subpropKey] || subpropKey;
                if (item[subpropKey] == null) {
                  delete textElem[_subpropKey];
                } else {
                  textElem[_subpropKey] = item[subpropKey];
                }
              })
            })
          });
        }
      })
    }
  } else if (action === "add") {
    if (!spec.layout.split.label.items) spec.layout.split.label.items = [];
    if (option.items?.constructor.name === "Object") spec.layout.split.label.items.push(option.items)
    else if (option.items?.constructor.name === "Array") spec.layout.split.label.items.push(...option.items)
  } else if (action === "remove") {
    if (option && option.items?.index !== undefined) {
      spec.layout.split.label.items = spec.layout.split.label.items.filter((d, i) => i != option.items.index);
    }
  }
  return spec;
}